// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  DeviceGroupControlContent,
  unionToDeviceGroupControlContent,
  unionListToDeviceGroupControlContent,
} from "./device-group-control-content";
import {
  ElevatorGroupControlMessage,
  ElevatorGroupControlMessageT,
  verifyElevatorGroupControlMessage,
} from "./elevator-group-control-message";
import {
  EscalatorGroupControlMessage,
  EscalatorGroupControlMessageT,
  verifyEscalatorGroupControlMessage,
} from "./escalator-group-control-message";

export class GroupControlMessage implements flatbuffers.IUnpackableObject<GroupControlMessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): GroupControlMessage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsGroupControlMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: GroupControlMessage,
  ): GroupControlMessage {
    return (obj || new GroupControlMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsGroupControlMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: GroupControlMessage,
  ): GroupControlMessage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new GroupControlMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  messageType(): DeviceGroupControlContent {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : DeviceGroupControlContent.NONE;
  }

  message<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  static startGroupControlMessage(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addMessageType(builder: flatbuffers.Builder, messageType: DeviceGroupControlContent) {
    builder.addFieldInt8(0, messageType, DeviceGroupControlContent.NONE);
  }

  static addMessage(builder: flatbuffers.Builder, messageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, messageOffset, 0);
  }

  static endGroupControlMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // message
    return offset;
  }

  static createGroupControlMessage(
    builder: flatbuffers.Builder,
    messageType: DeviceGroupControlContent,
    messageOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    GroupControlMessage.startGroupControlMessage(builder);
    GroupControlMessage.addMessageType(builder, messageType);
    GroupControlMessage.addMessage(builder, messageOffset);
    return GroupControlMessage.endGroupControlMessage(builder);
  }

  unpack(): GroupControlMessageT {
    return new GroupControlMessageT(
      this.messageType(),
      (() => {
        const temp = unionToDeviceGroupControlContent(this.messageType(), this.message.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
    );
  }

  unpackTo(_o: GroupControlMessageT): void {
    _o.messageType = this.messageType();
    _o.message = (() => {
      const temp = unionToDeviceGroupControlContent(this.messageType(), this.message.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
  }

  unpackFields(...fields: string[]): GroupControlMessageT {
    const t = new GroupControlMessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("message_type")) {
      t.messageType = this.messageType();
    }
    if (fieldSet.has("message")) {
      t.message = (() => {
        const temp = unionToDeviceGroupControlContent(this.messageType(), this.message.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    return t;
  }
}

export class GroupControlMessageT implements flatbuffers.IGeneratedObject {
  constructor(
    public messageType: DeviceGroupControlContent = DeviceGroupControlContent.NONE,
    public message: ElevatorGroupControlMessageT | EscalatorGroupControlMessageT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.message === null || this.message === undefined) {
      throw new Error('Required field "message" is not set');
    }
    const message = builder.createObjectOffset(this.message);

    return GroupControlMessage.createGroupControlMessage(builder, this.messageType, message);
  }

  clone(): GroupControlMessageT {
    const obj = new GroupControlMessageT();
    obj.messageType = this.messageType;
    obj.message =
      this.message !== null && typeof (this.message as any).clone === "function"
        ? (this.message as any).clone()
        : this.message;
    return obj;
  }

  equals(other: GroupControlMessageT): boolean {
    if (this.messageType !== other.messageType) return false;
    if (this.message !== null && other.message !== null) {
      if (typeof (this.message as any).equals === "function") {
        if (!(this.message as any).equals(other.message)) return false;
      } else if (this.message !== other.message) return false;
    } else if (this.message !== other.message) return false;
    return true;
  }
}

export function verifyGroupControlMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkUnionConsistency(tablePos, 4, 6, "message");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 4);
        switch (uType) {
          case 1: // ElevatorGroupControlMessage
            {
              const o = verifier.readInt32(pos);
              verifyElevatorGroupControlMessage(verifier, pos + o);
            }
            break;
          case 2: // EscalatorGroupControlMessage
            {
              const o = verifier.readInt32(pos);
              verifyEscalatorGroupControlMessage(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 6, "message");
  } finally {
    verifier.popDepth();
  }
}
